// @flow
import { createAction } from 'redux-act';

export const fetchVenues = createAction('Fetch Venues');
export const fetchVenuesSuccess = createAction('Fetch Venues Success');
export const fetchVenuesFailed = createAction('Fetch Venues Failed');


// WEBPACK FOOTER //
// ./src/modules/actions/venues.js